import React, { useState } from 'react'
import moment from 'moment';
import { useStyle } from "./Style";
import Grid from "@material-ui/core/Grid";
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import { Switch } from '@mui/material';

const DeathClaimDetails = (props) => {
  const classes = useStyle();

  const [cause_of_death, setCause_of_death] = useState('');
  const [hospitalized, setHospitalized] = useState(false);
  const [sufferedChronicCondition, setSufferedChronicCondition] = useState(false);

  const handleChange = (event) => {
    const { name, value } = event.target;
    if (name === "cause_of_death") {
      setCause_of_death(value);
      handleSubmit(value)
    }

  }


  const handleSubmit = (value) => {

    const tempClaimInitiation = props.claimInitiationPayload;
    tempClaimInitiation["additional_details"] = {
      "age": getAge(),
      "cause_of_death": value,
      "hospitalized": hospitalized,
      "suffered_chronic_condition": sufferedChronicCondition,
    };
    props.setClaimInitiationPayload(tempClaimInitiation);
  }

  const getAge = () => {
    const dob = props.member.date_of_birth
    const dateOfDeath = props.eventDate
    const ageAtDeath = moment(dateOfDeath).diff(moment(dob), 'years');
    return ageAtDeath;
  };


  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12} md={12}>
          <div className={classes.headingclaim}>
            <h4>Deceased details</h4>
          </div>
        </Grid>
      </Grid>
      <ValidatorForm onSubmit={() => { }}>
        <Grid container spacing={2} className={classes.selectpolicyWrapper}>
          <Grid item xs={12} md={4} sm={4}>
            <TextValidator
              id="name"
              style={{ width: "100%" }}
              label="first_name"
              name='first_name'
              value={props.member.first_name}
              variant="outlined"
            />
          </Grid>

          <Grid item xs={12} md={4} sm={4}>
            <TextValidator
              id="middle_name"
              style={{ width: "100%" }}
              label="middle_name"
              name='middle_name'
              value={props.member.middle_name}
              variant="outlined"
            />
          </Grid>

          <Grid item xs={12} md={4} sm={4}>
            <TextValidator
              id="last_name"
              style={{ width: "100%" }}
              label="last_name"
              name='last_name'
              value={props.member.last_name}
              variant="outlined"
            />
          </Grid>

          <Grid item xs={12} md={4} sm={4}>
            <TextValidator
              id="relationship"
              style={{ width: "100%" }}
              label="relationship"
              name='relationship'
              value={props.member.relationship}
              onChange={handleChange}
              variant="outlined"
            />
          </Grid>

          <Grid item xs={12} md={4} sm={4}>
            <TextValidator
              id="gender"
              style={{ width: "100%" }}
              label="gender"
              name='gender'
              value={props.member.gender}
              variant="outlined"
            />
          </Grid>



          <Grid item xs={12} md={4} sm={4}>
            <TextValidator
              id="date_of_birth"
              style={{ width: "100%" }}
              label="date_of_birth"
              name='date_of_birth'
              value={props.member.date_of_birth}
              variant="outlined"
            />
          </Grid>



          <Grid item xs={12} md={4} sm={4}>
            <TextValidator
              id="age"
              style={{ width: "100%" }}
              label="age"
              name='age'
              value={getAge()}
              variant="outlined"
            />
          </Grid>

          <Grid item xs={12} md={4} sm={4}>
            <TextValidator
              id="date_of_death"
              style={{ width: "100%" }}
              label="date_of_death"
              name='date_of_death'
              value={props.eventDate}
              variant="outlined"
            />
          </Grid>

        </Grid>

        <Grid container spacing={2} className={classes.selectpolicyWrapper}>
          <Grid item xs={12} md={4} sm={4}>
            <label>is hospitalized: {hospitalized ? 'Yes' : 'No'} </label>
            <Switch
              checked={hospitalized}
              onChange={() => { setHospitalized(!hospitalized) }}
              inputProps={{ 'aria-label': 'controlled' }}
              validators={['']}
            />
          </Grid>

          <Grid item xs={12} md={4} sm={4}>
            <label>suffered chronic condition: {sufferedChronicCondition ? 'Yes' : 'No'} </label>
            <Switch
              checked={sufferedChronicCondition}
              onChange={() => { setSufferedChronicCondition(!sufferedChronicCondition) }}
              inputProps={{ 'aria-label': 'controlled' }}
              validators={['']}
            />
          </Grid>


          <Grid item xs={12} md={12} sm={12}>
            <TextValidator
              id="cause_of_death"
              style={{ width: "100%" }}
              label="cause_of_death"
              name='cause_of_death'
              value={cause_of_death}
              onChange={handleChange}
              variant="outlined"
            />
          </Grid>


        </Grid>
      </ValidatorForm>
    </>
  )
}

export default DeathClaimDetails

